module.exports = __webpack_public_path__ + "static/media/icon-faqs@2x.d6493f60.png";